module.exports = __webpack_public_path__ + "static/media/galerija_2019 (11).b51d9c00.jpg";